export const CLEAR_FNOL_CONTEXT = 'CLEAR_FNOL_CONTEXT';
export const CLEAR_FNOL_MARKDOWN = 'CLEAR_FNOL_MARKDOWN';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_FILE_UPLOAD = 'SET_FILE_UPLOAD';
export const SET_FNOL_ANSWERS = 'SET_FNOL_ANSWERS';
export const SET_FNOL_CATEGORIES = 'SET_FNOL_CATEGORIES';
export const SET_FNOL_INTRO_MARKDOWN = 'SET_FNOL_INTRO_MARKDOWN';
export const SET_FNOL_KEY = 'SET_FNOL_KEY';
export const SET_FNOL_TEMPLATE = 'GET_FNOL_TEMPLATE';
export const GET_FNOL_TEMPLATES = 'GET_FNOL_TEMPLATES';
export const SET_INCIDENT_DAY = 'SET_INCIDENT_DAY';
export const SET_INSURANCE_HOLDER = 'SET_INSURANCE_HOLDER';
export const SET_INSURED_OBJECT = 'SET_INSURED_OBJECT';
export const SET_SELECTED_FNOL_TEMPLATE = 'SET_SELECTED_FNOL_TEMPLATE';
export const SET_SELECTED_FNOL_CATEGORY = 'SET_SELECTED_FNOL_CATEGORY';
export const SET_STEP = 'SET_STEP';
export const SET_TELEPHONE = 'SET_TELEPHONE';
